//
// Variables
// --------------------------------------------------

import { spacer } from '@spotify-internal/tokens';

export const navPadding = spacer.spacer24;
export const navMobileHeight = spacer.spacer64;
export const navDesktopHeight = spacer.spacer80;
